export enum UserFormAttemptStatus {
  New = 'new',
  InProgress = 'in_progress',
  PreAccepted = 'pre_accepted',
  Accepted = 'accepted',
  Rejected = 'rejected',
  UnderReview = 'under_review',
  Closed = 'closed'
}
